var staticStrUndefined = 'undefined'

module.exports = staticStrUndefined
